module.exports = __webpack_public_path__ + "img/8.bdb90835.png";